import React, { FC, ReactNode } from 'react';
import { Typography } from 'fronton-react';
import { LinkTextContainer, RoundedLinkContainer } from './styles';

type Props = {
  title: string;
  description: string;
  onClick?: () => void;
  testId?: string;
  className?: string;
  children?: ReactNode;
};

export const RoundedLink: FC<Props> = ({ title, children, onClick, testId, className, description }) => (
  <RoundedLinkContainer onClick={onClick} data-qa={testId} className={className}>
    <LinkTextContainer>
      <Typography variant="m" color="text-primary" size="subtitle">
        {title}
      </Typography>
      <Typography color="text-minor" variant="caption">
        {description}
      </Typography>
    </LinkTextContainer>
    {children}
  </RoundedLinkContainer>
);
